import * as React from 'react';
import { Dispatch } from 'redux';

import { ICartModel } from '../../cart/reducers/cart-reducer';
import { removeAllSeatsFromCart } from '../../cart/actions/cart-actions';
import { IAppSettingsModel } from '../../reducers/fetch-settings-reducer';
import { IApplicationModel } from '../../reducers/app-reducer';
import Modal from '../../common/modal/modal';


interface ICartTimerProps {
    cartTimerExpiringMinute: number;
    cartTimerMessaging: string;
    remainingCartTimer: number;
    cartUrl: string;
    cartExpiredTitle: string;
    cartExpiredMessage: string;
    cartExpiredConfirmText: string;
    disableCartExpiredPopup: boolean;
}

class CartTimer extends React.Component<ICartTimerProps, { seconds: any, minutes: any, expiring: boolean, expired: boolean }>{
    private startSecondsRemaining: number;    
    private intervalHandle: number;
    private startTime: Date;
    private timerRef: React.RefObject<HTMLDivElement>;

    constructor(props) {
        super(props);

        this.startTime = new Date();
        this.handleChange = this.handleChange.bind(this);
        this.tick = this.tick.bind(this);
        this.startCountDown = this.startCountDown.bind(this);
        this.handleVisibilityChange = this.handleVisibilityChange.bind(this);

        this.timerRef = React.createRef<HTMLDivElement>();

        if (props.remainingCartTimer > 0) {
            const startingMinutes = Math.floor(props.remainingCartTimer);
            const startingSeconds = Math.floor((+(props.remainingCartTimer % 1).toFixed(4)) * 60);
            this.startSecondsRemaining = (+startingMinutes * 60) + startingSeconds;            

            this.state = {
                ...this.state,
                minutes: startingMinutes,
                seconds: startingSeconds,
                expiring: false
            };
            this.startCountDown();
        } else {
            this.state = {
                seconds: '0',
                minutes: '',
                expiring: false,
                expired: false
            }
        }
        this.startSecondsRemaining;
        this.intervalHandle;

    }

    handleChange(event) {
        this.setState({
            minutes: event.target.value
        })
    }

    tick() {
        const currentTime = new Date();

        // in seconds
        const elapsedTime = Math.floor((currentTime.getTime() - this.startTime.getTime()) / 1000);

        const secondsRemaining = this.startSecondsRemaining - elapsedTime;

        const min = Math.floor(secondsRemaining / 60);
        const sec = secondsRemaining - (min * 60);

        let newSeconds = sec.toString();
        let newMinutes = min.toString();        
        var expiring = false;

        if (sec < 10 && newSeconds.length < 2) {
            newSeconds = "0" + newSeconds;
        }
        if (min < 10 && newMinutes.length < 2) {
            newMinutes = "0" + newMinutes;
        }

        if (secondsRemaining < 0) {
            newSeconds = "00";
            newMinutes = "00";
            expiring = true;
        }

        if (secondsRemaining < 0) {
            clearInterval(this.intervalHandle);
            this.setState({ ...this.state, expired: true });
        }
        this.setState({
            minutes: newMinutes,
            seconds: newSeconds,
            expiring: expiring
        });        
    }

    startCountDown() {
        var appContainer = document.getElementById('app-container');
        appContainer.classList.add('cart-timer-active');

        this.intervalHandle = setInterval(this.tick, 1000);        
    }

    componentWillReceiveProps(nextProps: ICartTimerProps) {
        if (this.props.remainingCartTimer !== nextProps.remainingCartTimer
            && this.state.minutes.length === 0) {
            this.setState({
                ...this.state,
                minutes: nextProps.remainingCartTimer
            });
            this.startCountDown();
        }
    }

    componentDidMount() {
        if (this.timerRef?.current) {
            setTimeout(() => {
                const timerHeight = this.timerRef.current.offsetHeight;
                document.body.style.setProperty('--timer-height', `${timerHeight}px`);
            }, 0);
        }

        document.addEventListener("visibilitychange", this.handleVisibilityChange);
    }

    componentWillUnmount() {
        // Remove visibility change listener
        document.removeEventListener("visibilitychange", this.handleVisibilityChange);
    }

    currentTimerMsg() {
        return { __html: this.props.cartTimerMessaging.replace('{1}', "<span>" + this.state.minutes + ":" + this.state.seconds + "</span>") };
    }

    reloadPage() {
        location.reload();
    }

    handleVisibilityChange() {
        if (document.visibilityState !== "hidden") {
            this.startCountDown();
        } else {
            clearInterval(this.intervalHandle);
        }
    }

    render() {
        return (
            <>
                <div className={'cart-timer' + (this.state.expiring ? ' cart-timer-expiring' : '')} ref={this.timerRef}>
                    <div className="cart-timer-inner">
                        <p className="caption-paragraph" dangerouslySetInnerHTML={this.currentTimerMsg()} />
                    </div>
                </div>
                {
                    this.state.expired && !this.props.disableCartExpiredPopup ?
                        <Modal title={this.props.cartExpiredTitle}
                            isError={true}
                            message={this.props.cartExpiredMessage}
                            modalKey="cart expired"
                            confirmString={this.props.cartExpiredConfirmText}
                            confirmFunction={this.reloadPage.bind(this)}
                        />
                        : null
                }
            </>
        );
    }

}

export default CartTimer;
